import { create } from 'zustand';

type CollapsedDaysState = {
  collapsedDays: Set<number>;
  toggle: (dayIndex: number) => void;
  collapseAll: (dayIndexes: number[]) => void;
  expandAll: () => void;
};

export const useCollapsedDaysStore = create<CollapsedDaysState>((set) => ({
  collapsedDays: new Set(),
  toggle: (dayIndex) =>
    set((s) => {
      const next = new Set(s.collapsedDays);
      if (next.has(dayIndex)) next.delete(dayIndex);
      else next.add(dayIndex);
      return { collapsedDays: next };
    }),
  collapseAll: (dayIndexes) => set({ collapsedDays: new Set(dayIndexes) }),
  expandAll: () => set({ collapsedDays: new Set() }),
}));
